import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '@app/services/User/user.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit{

  public userIsAuthenticated = false;
  public currentYear = new Date().getFullYear();

  
  constructor(
    private router: Router,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0)
    });
  }

  ngAfterViewInit() {
    this.userIsAuthenticated = this.userService.isLoggedIn();

    const script = document.createElement('script');
    //script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    //script.src = 'https://mercury.phonepe.com/web/bundle/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  }

}
